import React, {useEffect, useState} from "react";
import {useJson} from "../../shared/utils/json";
import {text} from "../../shared/utils/i18n";
import isURL from "validator/lib/isURL";
import {createRoot} from "react-dom/client";
import {getAndStripAttribute} from "../../shared/utils/dom-container-util";
import {flushSync} from "react-dom";

const RWPFavoriteLinksContainer = (props) => {
	const { parseJson, htmlDecode } = useJson();
	const model = parseJson(props.model);
	let [linkList, setLinkList] = useState(model);
	const btnDisabled = linkList.length >= 10;

	useEffect(() => {
		let unsavedChangesArr = linkList.map((link, i) => {
			return link.unsavedChanges;
		});

		if (unsavedChangesArr.some((e) => e)) {
			$('#save').attr('disabled', true).addClass('btn-disable');
		} else {
			$('#save').attr('disabled', false).removeClass('btn-disable');
		}
	}, [linkList]);

	const handleNewLink = (e) => {
		e.preventDefault();
		if (linkList.length < 10) {
      flushSync(() => {
        setLinkList([...linkList, {"linkTitle": "", "longLink": "", "shortKey": "", "unsavedChanges": false}]);
      });
		}
	};

	const handleUpdateLink = position => (e) => {
		let updatedLink = {
			"linkTitle": document.getElementById("linkTitle" + position).value,
			"longLink": document.getElementById("linkURL" + position).value,
			"shortKey": e.target.getAttribute("data-link-id"),
			"unsavedChanges": document.getElementById("linkTitle" + position).value !== "" && document.getElementById("linkURL" + position).value !== ""
		};
		updateLink(updatedLink, position);
	};

	const handleSaveLink = position => (e) => {
		let urlToSubmit = linkList[position].longLink;
		if (isURL(urlToSubmit)) {
			if (!urlToSubmit.match(/^https?:\/\//)) {
				urlToSubmit = "https://" + urlToSubmit;
			}
			requestAnimationFrame(() => {
				$.ajax({
					url: contextPath + "/my-account/settings/rwp-link-create",
					type: 'POST',
					data: { "longLink": urlToSubmit, "linkTitle": linkList[position].linkTitle, "shortKey": linkList[position].shortKey },
					success: function (result) {
						if(result.hasError) {
							// helper function defined in global.js
							// eslint-disable-next-line no-undef
							showGlobalErrorMessage(text('replicated.error.invalid.link'), {ariaMessage: text('replicated.error.invalid.link')});
						} else {
							result.unsavedChanges = false;
							updateLink(result, position);
							// helper function defined in global.js
							// eslint-disable-next-line no-undef
							showGlobalSuccessMessage(text('replicated.response.link.saved'), {timer: true, onEscape: true, backdrop: true, ariaMessage: text('replicated.response.link.saved')});
						}
					},
					error: function (status) {
						console.log('error: ' + status);
						// helper function defined in global.js
						// eslint-disable-next-line no-undef
						showGlobalErrorMessage(text('replicated.error.try.again'), {ariaMessage: text('replicated.error.try.again')});
					}
				});
			});
		} else {
			// helper function defined in global.js
			// eslint-disable-next-line no-undef
			showGlobalErrorMessage(text('replicated.error.invalid.link'), {ariaMessage: text('replicated.error.invalid.link')});
		}
	};

	const handleDeleteLink = position => (e) => {
		requestAnimationFrame(() => {
			$.ajax({
				url: contextPath + "/my-account/settings/rwp-link-remove",
				type: 'POST',
				data: { "shortKey": linkList[position].shortKey },
				success: function (result) {
					let newList = linkList;
					newList.splice(position, 1);
	        flushSync(() => {
	          setLinkList([...newList]);
	        });

					// helper function defined in global.js
					// eslint-disable-next-line no-undef
					showGlobalSuccessMessage(text('replicated.response.link.removed'), {timer: true, onEscape: true, backdrop: true, ariaMessage: text('replicated.response.link.removed')});
				},
				error: function (status) {
					console.log('error: ' + status);
					// helper function defined in global.js
					// eslint-disable-next-line no-undef
					showGlobalErrorMessage(text('replicated.error.try.again'), {ariaMessage: 'replicated.error.try.again'});
				}
			});
		});
	};

	const updateLink = (updatedLink, position) => {
		const newList = linkList.map((link,i) => {
			if (position === i) {
				return updatedLink;
			} 
				return link;
			
		});
		setLinkList(newList);
	};

	return (
		<>
			<div className='rwp-favorite-links-header'>
				<h2>{text('replicated.favorite.links')}</h2>
				<a href={`${contextPath}/link-generator/v2`} target="_blank" rel="noreferrer" className="new-link" aria-label={text('replicated.settings.create.link')}><i className="icon--link icon--sm"></i> {text('replicated.settings.create.link')}</a>
			</div>
			<div className="rwp-favorite-links-body">
				{linkList.map((link, i) => {
					return (
						<div key={i} className="link-row">
							<div key={i} className="link-fields">
								<input id={`linkTitle${i}`} placeholder={text('replicated.settings.link.title')} aria-label={text('replicated.settings.link.title')} value={htmlDecode(link.linkTitle)} onChange={handleUpdateLink(i)} data-link-id={link.shortKey} />
								<input id={`linkURL${i}`} placeholder={text('replicated.settings.link.url')} aria-label={text('replicated.settings.link.url')} value={link.longLink} onChange={handleUpdateLink(i)} data-link-id={link.shortKey} />
								<span className="save-section">{link.unsavedChanges ? <a className="btn btn-secondary btn-small" aria-label={text('replicated.settings.action.save')} onClick={handleSaveLink(i)}>{text('form.generic.button.save')}</a> : <i className="icon--tick icon--no-hover" aria-label={text('replicated.response.link.saved')} />}</span>
							</div>
							<a className="icon--cross" onClick={handleDeleteLink(i)} aria-label={text('replicated.settings.action.delete')} />
						</div>
					);
				})}
			</div>
			<button onClick={handleNewLink} className="btn btn-secondary" disabled={btnDisabled} aria-label={text('replicated.settings.add.link')}>{text('replicated.settings.add.link')}</button>
		</>
	);
};

const domContainer = document.querySelector('#rwp-favorite-links-container');
if (domContainer) {
  const model = getAndStripAttribute("data-model", domContainer);
  const root = createRoot(domContainer);
  root.render(<RWPFavoriteLinksContainer model={model}/>);
}

